export const getLocationSearch = (target = window) => {
  return target.location.search;
};